import type { ISegment } from '@feathr/blackbox';
import { ensurePredicateKeys } from '@feathr/blackbox';

/** The query parameter that opens the people list filtered to one tag. */
export const TAG_FILTER_PARAM = 'tag';

/** The people list, filtered to the people who have this tag. Not prefixed with the account. */
export function getTaggedPeopleUrl(tagId: string): string {
  return `/data/explore/all/people?${new URLSearchParams({ [TAG_FILTER_PARAM]: tagId })}`;
}

/** A filter for the people who have this tag, written as the API writes an import's group. */
export function getTagSegment(tagId: string): Partial<ISegment> {
  return {
    mode: 'match_all',
    lookback_mode: 'unbounded',
    lookback_value: 0,
    predicates: [
      ensurePredicateKeys({
        kind: 'attribute',
        attr_against: 'tag_ids',
        attr_type: 'list',
        comparison: 'in',
        value: [tagId],
        group: [],
      }),
    ],
  };
}
